// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__tH1kN","fileBtn":"File_fileBtn__2kISv","closeBtn":"File_closeBtn__2rsur","fileSelected":"File_fileSelected__28WhB","disabled":"File_disabled__2BNh-"};